import React from 'react'
import styles from './BrowserButtonStyles.module.scss'
import {ReactComponent as ChromeIcon} from './chrome-icon.svg'
import {ReactComponent as EdgeIcon} from './edge-icon.svg'

const BrowserButton = ({link, children}) => {
    return <a target="_blank" className={styles['browser-button-link']} href={link} rel="noreferrer">
        <div className={styles['browser-button']}>
            {children}
        </div>
    </a>
}

export const ChromeButton = () => {
    return <BrowserButton link="https://www.google.com/chrome/" >
            <ChromeIcon className={styles['browser-icon']} />Download Chrome
        </BrowserButton>
}

export const EdgeButton = () => {
    return <BrowserButton link="https://www.microsoft.com/en-us/edge" >
            <EdgeIcon className={styles['browser-icon']} />Download Edge
        </BrowserButton>
}